<template>
    <transition name="fade">
        <div class="toast" v-show="theToast">
            {{msg}}
        </div>
    </transition>
</template>
 
<script>
    export default {
        data() {
            return {
                theToast: false,
                msg: ""
            };
        }
    };
</script>
 
<style scoped>
    .toast {
        position: fixed;
        bottom: 50%;
        left: 50%;
        transform: translateX(-50%);
        padding: 10px 30px;
        font-size: 14px;
        color: #fff;
        text-align: center;
        background-color: rgba(0, 0, 0, 0.6);
        border-radius: 8px;
        z-index: 11999;
    }
     
    .fade-enter-active,
    .fade-leave-active {
        transition: 0.3s ease-out;
    }
     
    .fade-enter {
        opacity: 0;
    }
     
    .fade-leave-to {
        opacity: 0;
    }
</style>